import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { createBrowserHistory } from 'history';
import { routerMiddleware } from 'react-router-redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import { loadUser } from 'redux-oidc';

import reducer from './reducer';
import userManager from './utils/userManager';

export const history = createBrowserHistory();
const middleware = [routerMiddleware(history), thunk];

export const store = createStore(
  reducer,
  composeWithDevTools(applyMiddleware(...middleware))
);
loadUser(store, userManager);

export default store;
